// @packages
import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { View } from 'react-native';

// @scripts
import ForgotPasswordForm from '../../components/organisms/forgot-password-form';
import useStyles from './styles';

const ForgotPassword = () => {
  const styles = useStyles();
  return (
    <View style={styles.container}>
      <ForgotPasswordForm />
      <StatusBar style="auto" />
    </View>
  );
};

export default ForgotPassword;
